import { NavLink, Outlet } from 'react-router-dom';
import Icon from '../../components/common/Icon';

const sections = [
  { to: '/settings/chambers',          label: 'Chambers',     icon: 'briefcase' as const },
  { to: '/settings/profile',           label: 'My profile',   icon: 'user'      as const },
  { to: '/settings/members',           label: 'Members',      icon: 'users'     as const },
  { to: '/settings/permissions',       label: 'Permissions',  icon: 'shield-check' as const },
  { to: '/settings/rates',             label: 'Rates',        icon: 'price-tag' as const },
  { to: '/settings/courts',            label: 'Courts & forums', icon: 'balance-scale' as const },
  { to: '/settings/court-calendar',    label: 'Court calendar',  icon: 'calendar' as const },
  { to: '/settings/integrations/ai',   label: 'AI provider',  icon: 'sparkle'   as const },
  { to: '/settings/ai-audit',          label: 'AI audit',     icon: 'shield-check' as const },
  { to: '/settings/integrations/smtp', label: 'Email (SMTP)', icon: 'mail'      as const },
  { to: '/settings/integrations/xero', label: 'Xero',         icon: 'globe'     as const },
  { to: '/settings/integrations/calendar', label: 'Calendar', icon: 'calendar'  as const },
  { to: '/settings/integrations/payfast', label: 'PayFast',   icon: 'credit-card' as const },
  { to: '/settings/bank-imports',      label: 'Bank CSV imports', icon: 'document' as const },
  { to: '/settings/billing',           label: 'Billing',      icon: 'credit-card' as const },
  { to: '/settings/compliance',        label: 'Compliance',   icon: 'shield-star' as const },
];

export default function SettingsLayout() {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: 24, alignItems: 'start' }}>
      <aside className="card" style={{ padding: 6, position: 'sticky', top: 24 }}>
        {sections.map((s) => (
          <NavLink
            key={s.to}
            to={s.to}
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '8px 10px', margin: '1px 0',
              borderRadius: 6, textDecoration: 'none',
              fontSize: 13, fontWeight: isActive ? 600 : 500,
              color: isActive ? 'var(--color-accent)' : 'var(--color-text)',
              background: isActive ? 'rgba(201, 163, 74, 0.12)' : 'transparent',
            })}
          >
            <Icon name={s.icon} size={15} />
            <span>{s.label}</span>
          </NavLink>
        ))}
      </aside>
      <div style={{ minWidth: 0 }}>
        <Outlet />
      </div>
    </div>
  );
}
